export const featureFlagsConst = [
  "manage_locations",
  "aichatboot",
  "invoices",
  "dashboards_data_v2",
] as const;
export type FeatureFlags = (typeof featureFlagsConst)[number];
